import styled from 'styled-components'

const Aside = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: calc(100% - 64px);
  top: 64px;
  right: ${props => (props.show ? 0 : -100)}%;
  transition: right 0.5s ease-in-out;

  @media (min-width: 768px) {
    position: fixed;
    top: 64px;
    right: 0;
    height: calc(100% - 64px);
    width: 50%;
  }

  @media (min-width: 992px) {
    width: 33.33%;
  }
`

export default Aside
